import React from 'react';

const METODOS = ['Efectivo', 'Transferencia', 'POS', 'Cheque'];

export const lineaVacia = (monto = '') => ({
  metodo: 'Efectivo', monto, cuenta_bancaria_id: '', pos_id: '', comprobante: ''
});

// Devuelve un mensaje de error, o null si el desglose es válido.
export const validarPagoMixto = (pagos, total) => {
  if (!pagos || pagos.length === 0) return 'Debe agregar al menos una línea de pago';
  for (const p of pagos) {
    const monto = parseFloat(p.monto) || 0;
    if (monto <= 0) return 'Cada línea debe tener un monto mayor a 0';
    if (p.metodo === 'Transferencia' && !p.cuenta_bancaria_id) return 'Debe seleccionar la cuenta bancaria en cada línea de Transferencia';
    if (p.metodo === 'POS' && !p.pos_id) return 'Debe seleccionar la terminal POS en cada línea de POS';
    if (p.metodo === 'Cheque' && !(p.comprobante || '').trim()) return 'Debe indicar el número de cheque/referencia';
  }
  const suma = pagos.reduce((s, p) => s + (parseFloat(p.monto) || 0), 0);
  if (Math.abs(suma - (parseFloat(total) || 0)) > 0.01) {
    return `La suma del desglose (Q${suma.toFixed(2)}) no coincide con el monto a pagar (Q${(parseFloat(total) || 0).toFixed(2)})`;
  }
  return null;
};

const PagoMixtoForm = ({ pagos, onChange, total, cuentas = [], posTerminales = [] }) => {
  const suma = pagos.reduce((s, p) => s + (parseFloat(p.monto) || 0), 0);
  const diferencia = parseFloat(((parseFloat(total) || 0) - suma).toFixed(2));

  const actualizarLinea = (idx, campo, valor) => {
    onChange(pagos.map((p, i) => i === idx ? { ...p, [campo]: valor } : p));
  };

  const agregarLinea = () => {
    onChange([...pagos, lineaVacia(diferencia > 0 ? diferencia.toFixed(2) : '')]);
  };

  const quitarLinea = (idx) => {
    onChange(pagos.filter((_, i) => i !== idx));
  };

  return (
    <div style={{ border: '1px solid var(--border-color)', borderRadius: '8px', padding: '12px', marginBottom: '8px' }}>
      {pagos.map((p, idx) => (
        <div key={idx} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr auto', gap: '8px', alignItems: 'end', marginBottom: '10px' }}>
          <div className="form-group" style={{ marginBottom: 0 }}>
            <label className="form-label" style={{ fontSize: '11px' }}>Método</label>
            <select className="form-control" value={p.metodo}
              onChange={(e) => actualizarLinea(idx, 'metodo', e.target.value)}>
              {METODOS.map(m => <option key={m} value={m}>{m}</option>)}
            </select>
          </div>
          <div className="form-group" style={{ marginBottom: 0 }}>
            <label className="form-label" style={{ fontSize: '11px' }}>Monto (Q)</label>
            <input type="number" step="0.01" min="0" className="form-control"
              value={p.monto} onChange={(e) => actualizarLinea(idx, 'monto', e.target.value)} />
          </div>
          {p.metodo === 'Transferencia' && (
            <div className="form-group" style={{ marginBottom: 0 }}>
              <label className="form-label" style={{ fontSize: '11px' }}>Cuenta Bancaria</label>
              <select className="form-control" value={p.cuenta_bancaria_id}
                onChange={(e) => actualizarLinea(idx, 'cuenta_bancaria_id', e.target.value)}>
                <option value="">-- Seleccionar --</option>
                {cuentas.map(c => <option key={c.id} value={c.id}>{c.nombre} - {c.banco}</option>)}
              </select>
            </div>
          )}
          {p.metodo === 'POS' && (
            <div className="form-group" style={{ marginBottom: 0 }}>
              <label className="form-label" style={{ fontSize: '11px' }}>Terminal POS</label>
              <select className="form-control" value={p.pos_id}
                onChange={(e) => actualizarLinea(idx, 'pos_id', e.target.value)}>
                <option value="">-- Seleccionar --</option>
                {posTerminales.map(t => <option key={t.id} value={t.id}>{t.nombre}</option>)}
              </select>
            </div>
          )}
          {p.metodo === 'Cheque' && (
            <div className="form-group" style={{ marginBottom: 0 }}>
              <label className="form-label" style={{ fontSize: '11px' }}>No. Cheque / Ref.</label>
              <input type="text" className="form-control" value={p.comprobante}
                onChange={(e) => actualizarLinea(idx, 'comprobante', e.target.value)} />
            </div>
          )}
          {p.metodo === 'Efectivo' && <div />}
          <button
            type="button"
            onClick={() => quitarLinea(idx)}
            disabled={pagos.length <= 1}
            style={{ background: 'none', border: 'none', color: 'var(--danger-color)', cursor: pagos.length <= 1 ? 'default' : 'pointer', fontSize: '18px', opacity: pagos.length <= 1 ? 0.3 : 1, padding: '0 8px' }}
          >
            &times;
          </button>
        </div>
      ))}
      <button type="button" onClick={agregarLinea} className="btn btn-secondary btn-sm" style={{ marginBottom: '10px' }}>
        + Agregar método
      </button>
      <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: '8px', fontSize: '13px', padding: '8px 10px', background: diferencia !== 0 ? '#fff5f5' : '#f0fff4', borderRadius: '6px' }}>
        <span>Asignado: <strong>Q{suma.toFixed(2)}</strong> / Monto a pagar: <strong>Q{(parseFloat(total) || 0).toFixed(2)}</strong></span>
        {diferencia !== 0 && (
          <span style={{ color: 'var(--danger-color)', fontWeight: 600 }}>
            {diferencia > 0 ? `Falta Q${diferencia.toFixed(2)}` : `Sobran Q${Math.abs(diferencia).toFixed(2)}`}
          </span>
        )}
      </div>
    </div>
  );
};

export default PagoMixtoForm;
